import { render, staticRenderFns } from "./Addresslist.vue?vue&type=template&id=e632207e&scoped=true&"
import script from "./Addresslist.vue?vue&type=script&lang=js&"
export * from "./Addresslist.vue?vue&type=script&lang=js&"
import style0 from "./Addresslist.vue?vue&type=style&index=0&id=e632207e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e632207e",
  null
  
)

export default component.exports